import * as B from '@blueprintjs/core';
import React from 'react';

import {formatCost} from 'app/utils/costUtils';
import * as imageryUtils from 'app/utils/imageryUtils';

import type {UsageLine} from '../grouping';
import cs from './styles.module.scss';

/** How much of each spending limit and prepaid the cart draws on was used before this order. */
export const UsageLimits: React.FC<{lines: UsageLine[]}> = ({lines}) => (
  <section className={cs.card} aria-labelledby="cart-usage-heading">
    <header className={cs.header}>
      <h2 id="cart-usage-heading">Usage and limits</h2>
    </header>

    <div className={cs.body}>
      {lines.map((line) => {
        const leftCents = Math.max(0, line.totalCents - line.usedCents);
        return (
          <div key={line.key} className={cs.line}>
            <div className={cs.lineHeading}>
              <span className={cs.label}>
                {line.label}
                {line.portfolios && <span className={cs.portfolios}>{line.portfolios}</span>}
              </span>
              <span className={cs.left}>{formatCost(leftCents)} left</span>
            </div>
            {/* Decorative: the amounts around the bar say everything it shows. */}
            <div aria-hidden>
              <B.ProgressBar
                value={line.totalCents > 0 ? line.usedCents / line.totalCents : 1}
                intent={leftCents > 0 ? B.Intent.PRIMARY : B.Intent.DANGER}
                animate={false}
                stripes={false}
              />
            </div>
            <div className={cs.scale}>
              <span>
                {formatCost(line.usedCents)} used
                {line.since && ` since ${imageryUtils.formatDate(line.since)}`}
              </span>
              <span>{formatCost(line.totalCents)}</span>
            </div>
          </div>
        );
      })}
    </div>
  </section>
);

export default UsageLimits;
